import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

const CHANNEL_META = {
  Call: { icon: faPhone, color: 'text-emerald-400', extraLabel: 'Call duration (minutes)' },
  WhatsApp: { icon: faWhatsapp, color: 'text-green-400', extraLabel: 'Message template used' },
  Email: { icon: faEnvelope, color: 'text-cyan-400', extraLabel: 'Subject line' },
};

// Usage: <MiniERPTrasContactModal channel="Call" onSave={payload => ...} onClose={() => ...} />
const MiniERPTrasContactModal = ({ channel, onSave, onClose }) => {
  const meta = CHANNEL_META[channel] || CHANNEL_META.Call;
  const [extra, setExtra] = useState('');
  const [remarks, setRemarks] = useState('');
  const [followUpDate, setFollowUpDate] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({ channel, extra, remarks, followUpDate: followUpDate || null });
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-3xl w-full max-w-md p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className={`text-xl font-bold flex items-center gap-2 ${meta.color}`}>
            <FontAwesomeIcon icon={meta.icon} /> {channel} Contact
          </h2>
          <button onClick={onClose} className="w-fit px-2 py-1 text-gray-400 hover:text-white">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-400 mb-1 text-sm">{meta.extraLabel}</label>
            <input type="text" value={extra} onChange={(e) => setExtra(e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-xl px-3 py-2" />
          </div>
          <div>
            <label className="block text-gray-400 mb-1 text-sm">Remarks</label>
            <textarea value={remarks} onChange={(e) => setRemarks(e.target.value)} style={{ height: '80px' }}
              className="w-full bg-gray-700 border border-gray-600 rounded-xl px-3 py-2" />
          </div>
          <div>
            <label className="block text-gray-400 mb-1 text-sm">Follow-up Date <span className="text-gray-500">(optional)</span></label>
            <input type="date" value={followUpDate} onChange={(e) => setFollowUpDate(e.target.value)}
              className="w-full bg-gray-700 border border-gray-600 rounded-xl px-3 py-2" />
          </div>
          <div className="flex gap-3 pt-2">
            <button type="button" onClick={onClose} className="flex-1 w-fit px-2 py-1 border border-gray-600 rounded-xl hover:bg-gray-700">Cancel</button>
            <button type="submit" className="flex-1 w-fit px-2 py-1 bg-cyan-600 hover:bg-cyan-500 rounded-xl font-medium">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MiniERPTrasContactModal;
